import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import {
  ACTIVOSFIJOS_BAJAS_LISTA,
  ACTIVOSFIJOS_BAJAS_NUEVO,
  ACTIVOSFIJOS_BAJAS_EDITAR
} from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoPage from './nuevo'
import EditarPage from './editar'

export default function ActivosFijosBajasPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${ACTIVOSFIJOS_BAJAS_LISTA}`} component={ListaPage} />
        <Route path={`/${ACTIVOSFIJOS_BAJAS_NUEVO}`} component={NuevoPage} />
        <Route path={`/${ACTIVOSFIJOS_BAJAS_EDITAR}/:idBaja`} component={EditarPage} />
      </Switch>
    </Suspense>
  )
}
